// actions prefixed with @@ are not meant to be handled
// see https://stackoverflow.com/questions/41305492
export const AuthActions = {
  API_RESPONSE_ERROR: '@@auth/API_RESPONSE_ERROR',
  API_RESPONSE_SUCCESS: '@@auth/API_RESPONSE_SUCCESS',
  LOGIN_USER: '@@auth/LOGIN_USER',
  LOGOUT_USER: '@@auth/LOGOUT_USER',
  RESET: '@@auth/RESET',
};
